export const milestoneFormStyles = {
     title: {
          fontSize: '16px',
          fontWeight: 'bold',
          color: '#2A3F4D',
          mb: 2
     },
     inputContainer: {
          display: 'flex',
          flexDirection: 'row',
          gap: 2,
          height: '40px',
          alignItems: 'flex-start',
          justifyContent: 'flex-start',
          p: 0,
          width: '470px'
     },
     inputContainerWithMargin: {
          display: 'flex',
          flexDirection: 'row',
          gap: 2,
          height: '40px',
          alignItems: 'flex-start',
          justifyContent: 'flex-start',
          p: 0,
          width: '470px',
          mt: 3
     },
     textField: {
          mb: 2,
          '& .MuiInputBase-root': {
               bgcolor: '#FAFBFC',
               pl: 3,
               pr: 2,
               py: 2,
               '&:before': {
                    display: 'none'
               },
          },
          '& .MuiInputBase-input': {
               fontSize: '16px',
               color: '#9FB1BD',
               fontFamily: 'Karla, sans-serif',
               fontWeight: 400,
               lineHeight: '24px'
          }
     },
     divider: {
          borderTop: '1px solid #F4F6F9',
          width: '100%',
          my: 2
     },
     actionButtonsContainer: {
          display: 'flex',
          flexDirection: 'row',
          gap: 2,
          height: '50px',
          alignItems: 'flex-start',
          justifyContent: 'flex-start',
          px: 0,
          py: 2.5,
          width: '284px'
     },
     cancelButton: {
          display: 'flex',
          flexDirection: 'row',
          gap: 2,
          height: '38px',
          alignItems: 'center',
          justifyContent: 'center',
          px: 3,
          py: 2.5,
          borderRadius: 1,
          cursor: 'pointer',
          '&:hover': {
               bgcolor: 'rgba(0, 93, 170, 0.04)'
          }
     },
     cancelButtonText: {
          fontFamily: 'Karla, sans-serif',
          fontWeight: 'bold',
          fontSize: '14px',
          color: '#005DAA',
          lineHeight: '24px',
          textAlign: 'center'
     },
     saveButton: (isEnabled: boolean) => ({
          display: 'flex',
          flexDirection: 'row',
          gap: 2,
          height: '38px',
          alignItems: 'center',
          justifyContent: 'center',
          px: 3,
          py: 2.5,
          borderRadius: 1,
          cursor: 'pointer',
          bgcolor: isEnabled ? '#005DAA' : 'transparent',
          '&:hover': {
               bgcolor: isEnabled ? '#004A8A' : 'transparent'
          }
     }),
     saveButtonText: (isEnabled: boolean) => ({
          fontFamily: 'Karla, sans-serif',
          fontWeight: 'bold',
          fontSize: '14px',
          color: isEnabled ? '#FFFFFF' : '#9FB1BD',
          lineHeight: '24px',
          textAlign: 'center'
     }),
     cancelIconButton: {
          color: '#005DAA',
          '&:hover': {
               bgcolor: 'rgba(0, 93, 170, 0.04)'
          }
     },
     saveIconButton: (isEnabled: boolean) => ({
          color: isEnabled ? '#005DAA' : '#9FB1BD',
          '&:hover': {
               bgcolor: isEnabled ? 'rgba(0, 93, 170, 0.04)' : 'transparent'
          }
     })
}; 